import React from "react";

const ValueCard = ({
  icon: Icon,
  title,
  description,
  className,
  onclick = () => {},
}) => {
  return (
    <div
      className={`cursor-pointer p-[30px] h-fit rounded-lg border-slate-200 border-[0.8px] ${className}`} //shadow-sm flex flex-col hover:-translate-y-3 hover:shadow-2xl transition-all duration-300
      onClick={onclick}
    >
      <div className="bg-secondary1 rounded-full w-[70px] h-[70px] min-h-[70px] flex items-center justify-center ">
        <Icon className="w-8 h-8 text-white" />
      </div>

      <h3 className="text-[1.5rem] qhd:text-[1.5rem] font-medium pt-[24px]">
        {title}
      </h3>
      <div className="flex flex-col justify-between pt-[8px] mb-[8px]">
        <div className="qhd:text-[1rem] line-clamp-[8]">
          <p className="text-justify">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ValueCard;
